export default function calcPercentage(numerator: number, denominator: number): string {
  return ((numerator * 100) / denominator).toFixed(2);
}
